var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center"},_vm._l((_vm.langs),function(language,index){return _c('div',{key:language,staticClass:"lang-container",class:{
      'mr-0': index == _vm.langsCount - 1,
      'mr-2': index != _vm.langsCount - 1,
      'lang--chosen': _vm.nodeLang == language
    },on:{"click":function($event){return _vm.changeLang(language)}}},[_c('div',{staticClass:"lang-icon",style:(`background-image: url(${_vm.baseUrl}img/lang-${language}.svg);`)})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }